import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHandcycleNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.25 6v.045l2.018 1.264a2.253 2.253 0 11-.67 2.352l-1.156 1.156A.625.625 0 0110 11H6.917a9.643 9.643 0 01-3.01-.469 2.253 2.253 0 11.563-1.133 8.19 8.19 0 001.405.291L4.078 6.095l1.118-.559 1.911 3.822c.12.24.365.392.634.392h2l1.567-1.567-1.722-1.079A1.25 1.25 0 1110.25 6zm-9 3.003a1.003 1.003 0 102.005 0 1.003 1.003 0 00-2.005 0zM13.752 8a1.002 1.002 0 100 2.005 1.002 1.002 0 000-2.005z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHandcycleNormalXsmall;
